import { Injectable } from '@angular/core';
import { TransportationPaymentsStatus } from "@features/transportation-payments/enums/transportation-payments-status.enum";
import { DateRangeType } from "@shared/enums/date-range-type.enum";
import { Observable } from 'rxjs';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { map } from 'rxjs/operators';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper';
import { ApiConstant } from '@shared/constants/api.constant';
import { ShipmentSearchFields } from '@features/transportation-payments/utils/transportaions.enums';
import { IGetInvoicesTransportPayload } from '@features/transportation-payments/interfaces/transportation-payment-payload.interface';
import { TransportationPaymentDetails } from '@features/invoices/transportation-payment-details';
import { InvoiceTransportationDetails } from '@features/invoices/models/invoice-transportation-details';

@Injectable({
  providedIn: 'root'
})
export class TransportationPaymentsCommonService {

  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  getTransportationPayments(body: {
   fleetId: number;
    customerId: number;
    createdBy: number;
    paymentStatus: TransportationPaymentsStatus;
    offset: number;
    limit: number;
    dateRangeType: DateRangeType;
    startFrom: string;
    endAt: string;
    searchTerm: string;
    searchKey: ShipmentSearchFields
  }): Observable<TransportationPaymentDetails> {
    return this.baseAPI.get(ApiConstant.GET_TRANSPORTATION_PAYMENTS, { params: filterNullEntity<typeof body>(body) }).pipe(
      map((res) => {
        return this.mapper.fromJson(TransportationPaymentDetails, res.data);
      })
    );
  }

  getInvoicesTransportation(payload: IGetInvoicesTransportPayload): Observable<InvoiceTransportationDetails> {
    return this.baseAPI.get(ApiConstant.GET_INVOICES_TRANSPORTATION, { params: filterNullEntity<typeof payload>(payload) }).pipe(
      map((res) => {
        return this.mapper.fromJson(InvoiceTransportationDetails, res.data);
      })
    );
  }
}
